export interface Movie {
  id: string;
  title: string;
  year: number;
  rating: number;
  category: string;
  categorySlug: string;
  poster: string;
  description: string;
  director: string;
  actors: string[];
  duration: string;
  region: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
  updateDate: string;
}

export const movies: Movie[] = [
  {
    id: "movie-1",
    title: "流浪地球2",
    year: 2023,
    rating: 8.3,
    category: "电影",
    categorySlug: "movies",
    poster: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20style%2C%20futuristic%20space%20station%20with%20Earth%20in%20background%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20warm%20golden%20and%20deep%20blue%20tones%2C%20movie%20poster%20design%20with%20Chinese%20title%20text%20space%2C%20epic%20scale%2C%20high%20contrast%2C%20professional%20film%20poster%20aesthetic&width=600&height=800&seq=movie-poster-01&orientation=portrait",
    description: "太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。然而宇宙之路危机四伏，为了拯救地球，流浪地球时代的年轻人再次挺身而出，展开争分夺秒的生死之战。",
    director: "郭帆",
    actors: ["吴京", "刘德华", "李雪健", "沙溢"],
    duration: "173分钟",
    region: "中国大陆",
    tags: ["科幻", "冒险", "灾难"],
    isHot: true,
    isNew: false,
    updateDate: "2024-01-15",
  },
  {
    id: "movie-2",
    title: "满江红",
    year: 2023,
    rating: 7.8,
    category: "电影",
    categorySlug: "movies",
    poster: "https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20movie%20poster%2C%20ancient%20Song%20dynasty%20setting%2C%20red%20and%20black%20color%20scheme%2C%20mysterious%20atmosphere%2C%20traditional%20Chinese%20architecture%20background%2C%20dramatic%20lighting%2C%20film%20poster%20style%2C%20historical%20thriller%20aesthetic&width=600&height=800&seq=movie-poster-02&orientation=portrait",
    description: "南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信也不翼而飞。一个小兵与亲兵营副统领机缘巧合被裹挟进这巨大阴谋之中。",
    director: "张艺谋",
    actors: ["沈腾", "易烊千玺", "张译", "雷佳音"],
    duration: "159分钟",
    region: "中国大陆",
    tags: ["剧情", "悬疑", "历史"],
    isHot: true,
    isNew: false,
    updateDate: "2024-02-20",
  },
  {
    id: "movie-3",
    title: "孤注一掷",
    year: 2023,
    rating: 7.9,
    category: "电影",
    categorySlug: "movies",
    poster: "https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20movie%20poster%2C%20dark%20urban%20setting%2C%20mysterious%20atmosphere%2C%20neon%20light%20reflections%2C%20suspenseful%20mood%2C%20professional%20film%20poster%20design%2C%20warm%20amber%20and%20dark%20tones%2C%20cinematic%20composition&width=600&height=800&seq=movie-poster-03&orientation=portrait",
    description: "程序员潘生和模特安娜被海外高薪招聘吸引，出国淘金却意外落入境外诈骗工厂的陷阱。为了离开，两人准备向赌徒阿天和其女友小雨下手，从他们身上套现完成业绩。",
    director: "申奥",
    actors: ["张艺兴", "金晨", "咏梅", "王传君"],
    duration: "130分钟",
    region: "中国大陆",
    tags: ["剧情", "犯罪", "悬疑"],
    isHot: true,
    isNew: false,
    updateDate: "2024-03-10",
  },
  {
    id: "movie-4",
    title: "封神第一部：朝歌风云",
    year: 2023,
    rating: 7.7,
    category: "电影",
    categorySlug: "movies",
    poster: "https://readdy.ai/api/search-image?query=Chinese%20fantasy%20epic%20movie%20poster%2C%20ancient%20Chinese%20mythology%20theme%2C%20warriors%20in%20ancient%20armor%2C%20dramatic%20sky%20with%20storm%20clouds%2C%20golden%20and%20crimson%20color%20scheme%2C%20epic%20cinematic%20style%2C%20mythological%20creatures%20silhouette&width=600&height=800&seq=movie-poster-04&orientation=portrait",
    description: "殷商末年，纣王暴虐无道，天下大乱。姜子牙携封神榜下山，辅佐西周。昆仑仙人广收门徒，一场天地间的大战一触即发。",
    director: "乌尔善",
    actors: ["费翔", "李雪健", "黄渤", "于适"],
    duration: "148分钟",
    region: "中国大陆",
    tags: ["奇幻", "动作", "史诗"],
    isHot: false,
    isNew: true,
    updateDate: "2024-04-05",
  },
  {
    id: "movie-5",
    title: "狂飙",
    year: 2023,
    rating: 8.5,
    category: "电视剧",
    categorySlug: "tv-shows",
    poster: "https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20poster%2C%20two%20men%20facing%20each%20other%2C%20police%20and%20gangster%20contrast%2C%20dark%20urban%20night%20scene%2C%20dramatic%20lighting%2C%20Chinese%20TV%20drama%20poster%20style%2C%20intense%20atmosphere&width=600&height=800&seq=movie-poster-05&orientation=portrait",
    description: "以一线刑警安欣为代表的正义力量，与以高启强为代表的黑恶势力展开长达二十年的生死搏斗。通过群像叙事，展现扫黑行动中的黑白较量和复杂人性。",
    director: "徐纪周",
    actors: ["张译", "张颂文", "李一桐", "张志坚"],
    duration: "39集",
    region: "中国大陆",
    tags: ["剧情", "犯罪", "悬疑"],
    isHot: true,
    isNew: false,
    updateDate: "2024-01-28",
  },
  {
    id: "movie-6",
    title: "三体",
    year: 2023,
    rating: 8.2,
    category: "电视剧",
    categorySlug: "tv-shows",
    poster: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20TV%20series%20poster%2C%20three%20body%20problem%20theme%2C%20cosmic%20background%20with%20stars%2C%20mysterious%20alien%20civilization%20concept%2C%20dark%20and%20golden%20color%20scheme%2C%20scientific%20and%20philosophical%20atmosphere%2C%20cinematic%20TV%20drama%20poster&width=600&height=800&seq=movie-poster-06&orientation=portrait",
    description: "纳米科学家汪淼被警官史强带到联合作战中心，潜入名为'科学边界'的组织协助调查。过程中，汪淼接触到一个名为ETO的组织，发现其幕后统帅竟是叶文洁。",
    director: "杨磊",
    actors: ["张鲁一", "于和伟", "陈瑾", "王子文"],
    duration: "30集",
    region: "中国大陆",
    tags: ["科幻", "悬疑", "剧情"],
    isHot: false,
    isNew: true,
    updateDate: "2024-02-15",
  },
  {
    id: "movie-7",
    title: "庆余年第二季",
    year: 2024,
    rating: 8.0,
    category: "电视剧",
    categorySlug: "tv-shows",
    poster: "https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20TV%20drama%20poster%2C%20ancient%20Chinese%20palace%20setting%2C%20young%20man%20in%20traditional%20robes%2C%20golden%20warm%20lighting%2C%20dramatic%20composition%2C%20Chinese%20costume%20drama%20poster%20style%2C%20regal%20atmosphere&width=600&height=800&seq=movie-poster-07&orientation=portrait",
    description: "范闲在经历了生死考验后，再次回到京都。面对更加复杂的朝堂局势，他必须步步为营，在各方势力之间周旋，守护自己在意的人和事。",
    director: "孙皓",
    actors: ["张若昀", "李沁", "陈道明", "吴刚"],
    duration: "36集",
    region: "中国大陆",
    tags: ["古装", "权谋", "剧情"],
    isHot: true,
    isNew: false,
    updateDate: "2024-05-10",
  },
  {
    id: "movie-8",
    title: "间谍过家家",
    year: 2022,
    rating: 8.7,
    category: "动漫",
    categorySlug: "anime",
    poster: "https://readdy.ai/api/search-image?query=Japanese%20anime%20spy%20family%20poster%2C%20stylish%20spy%20family%20theme%2C%20man%20in%20suit%20woman%20and%20child%20with%20pink%20hair%2C%20colorful%20warm%20illustration%20style%2C%20anime%20poster%20design%2C%20clean%20composition%2C%20playful%20atmosphere&width=600&height=800&seq=movie-poster-08&orientation=portrait",
    description: "为了执行秘密任务，一流间谍黄昏必须组建一个临时家庭。他收养的女儿恰好是超能力者，而妻子则是职业杀手。三人互相隐藏身份，却逐渐产生了真正的羁绊。",
    director: "古桥一浩",
    actors: ["江口拓也", "种崎敦美", "早见沙织"],
    duration: "25集",
    region: "日本",
    tags: ["喜剧", "动作", "日常"],
    isHot: false,
    isNew: true,
    updateDate: "2024-02-01",
  },
  {
    id: "movie-9",
    title: "海贼王",
    year: 1999,
    rating: 9.5,
    category: "动漫",
    categorySlug: "anime",
    poster: "https://readdy.ai/api/search-image?query=One%20Piece%20anime%20poster%20style%2C%20pirate%20crew%20adventure%20theme%2C%20boy%20with%20straw%20hat%2C%20ocean%20and%20ship%20background%2C%20colorful%20anime%20illustration%2C%20dynamic%20action%20pose%2C%20Japanese%20anime%20art%20style%2C%20warm%20adventurous%20atmosphere&width=600&height=800&seq=movie-poster-09&orientation=portrait",
    description: "拥有财富、名声、权力，这世界上的一切的男人——海贼王哥尔·D·罗杰，在被行刑受死之前说了一句话，让全世界的人都涌向了大海。想得到我的宝藏吗？如果想要的话，那就到海上去找吧，我全部都放在那里。",
    director: "宇田钢之介",
    actors: ["田中真弓", "冈村明美", "中井和哉"],
    duration: "1000+集",
    region: "日本",
    tags: ["冒险", "热血", "友情"],
    isHot: true,
    isNew: false,
    updateDate: "2024-06-01",
  },
  {
    id: "movie-10",
    title: "跑男2024",
    year: 2024,
    rating: 7.2,
    category: "综艺",
    categorySlug: "variety",
    poster: "https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%2C%20group%20of%20celebrities%20running%20and%20laughing%2C%20bright%20outdoor%20setting%2C%20colorful%20and%20playful%20design%2C%20Chinese%20reality%20TV%20show%20poster%20style%2C%20energetic%20atmosphere%2C%20warm%20sunny%20lighting&width=600&height=800&seq=movie-poster-10&orientation=portrait",
    description: "全新一季跑男来袭！常驻嘉宾与新嘉宾齐聚一堂，在各大城市展开精彩纷呈的挑战与游戏。欢笑与感动并存，带你体验最真实的综艺魅力。",
    director: "姚译添",
    actors: ["李晨", "郑恺", "杨颖", "白鹿", "周深"],
    duration: "12期",
    region: "中国大陆",
    tags: ["真人秀", "搞笑", "竞技"],
    isHot: false,
    isNew: true,
    updateDate: "2024-05-20",
  },
  {
    id: "movie-11",
    title: "奥本海默",
    year: 2023,
    rating: 8.8,
    category: "电影",
    categorySlug: "movies",
    poster: "https://readdy.ai/api/search-image?query=Oppenheimer%20film%20poster%20style%2C%20man%20in%20fedora%20hat%2C%20nuclear%20explosion%20silhouette%2C%20black%20and%20orange%20color%20scheme%2C%20intense%20dramatic%20atmosphere%2C%20historical%20biopic%20poster%2C%20cinematic%20lighting%2C%20dark%20and%20powerful%20composition&width=600&height=800&seq=movie-poster-11&orientation=portrait",
    description: "讲述了美国'原子弹之父'罗伯特·奥本海默主导制造出世界上第一颗原子弹的故事。影片聚焦奥本海默在曼哈顿计划中的经历，以及随后他面临的政治迫害与道德困境。",
    director: "克里斯托弗·诺兰",
    actors: ["基里安·墨菲", "艾米莉·布朗特", "马特·达蒙"],
    duration: "180分钟",
    region: "美国",
    tags: ["传记", "历史", "剧情"],
    isHot: true,
    isNew: false,
    updateDate: "2024-03-25",
  },
  {
    id: "movie-12",
    title: "繁花",
    year: 2024,
    rating: 8.4,
    category: "电视剧",
    categorySlug: "tv-shows",
    poster: "https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20TV%20series%20poster%2C%201990s%20Shanghai%20setting%2C%20elegant%20woman%20in%20cheongsam%2C%20neon%20city%20night%20scene%2C%20nostalgic%20golden%20lighting%2C%20Chinese%20drama%20poster%20style%2C%20romantic%20and%20sophisticated%20atmosphere&width=600&height=800&seq=movie-poster-12&orientation=portrait",
    description: "九十年代的上海，阿宝凭借改革开放的春风和自己的努力，成为商界后起之秀。黄河路上，人人争相与阿宝合作。故事展现了那个充满机遇与挑战的时代里的风云变幻。",
    director: "王家卫",
    actors: ["胡歌", "马伊琍", "唐嫣", "辛芷蕾"],
    duration: "30集",
    region: "中国大陆",
    tags: ["剧情", "爱情", "年代"],
    isHot: false,
    isNew: false,
    updateDate: "2024-01-10",
  },
];

export const categories = [
  { name: "全部", slug: "all", icon: "ri-apps-line" },
  { name: "电影", slug: "movies", icon: "ri-film-line" },
  { name: "电视剧", slug: "tv-shows", icon: "ri-tv-line" },
  { name: "动漫", slug: "anime", icon: "ri-live-line" },
  { name: "综艺", slug: "variety", icon: "ri-emotion-laugh-line" },
];

export interface CategoryInfo {
  name: string;
  slug: string;
  icon: string;
  description: string;
}

export const categoryDetails: Record<string, CategoryInfo> = {
  all: {
    name: "全部影视",
    slug: "all",
    icon: "ri-apps-line",
    description: "久久影视为您聚合海量高清影视资源，涵盖电影、电视剧、动漫、综艺等多种类型，全部免费在线观看，画质清晰流畅。",
  },
  movies: {
    name: "电影",
    slug: "movies",
    icon: "ri-film-line",
    description: "久久影视电影频道汇聚全球高清大片，从国产佳作到好莱坞巨制，从经典老片到最新上映，画质超清不缓冲，免费在线观看高清电影尽在久久影视。",
  },
  "tv-shows": {
    name: "电视剧",
    slug: "tv-shows",
    icon: "ri-tv-line",
    description: "久久影视电视剧频道为您提供最新最全的高清电视剧免费观看服务，国产剧、港剧、韩剧、美剧应有尽有，热门剧集追剧不等待。",
  },
  anime: {
    name: "动漫",
    slug: "anime",
    icon: "ri-live-line",
    description: "久久影视动漫频道汇集热门日漫、国漫、经典番剧，高清画质流畅播放，热血冒险、恋爱治愈、搞笑日常各类题材全覆盖。",
  },
  variety: {
    name: "综艺",
    slug: "variety",
    icon: "ri-emotion-laugh-line",
    description: "久久影视综艺频道提供最新综艺节目在线观看，热门真人秀、音乐竞演、脱口秀等精彩内容持续更新，高清免费看不停。",
  },
};